import ZtServiceFactory from '@src/services/zt';
const $ztService = ZtServiceFactory.getDefaultInstance();
const Service = {
    /**
     * 典藏礼包-获取配置
     * @returns {*}
     */
    // getConfig: () => $ztService.getGiftPackConfig(),
    /**
     * 公测礼包-基本配置
     * @returns {*}
     */
    gwConfig: () => $ztService.gwConfig(),
    /**
     *  获得预约福利码
     */
    getAppointmentCode: () => $ztService.getCodeInSubscribe(),
    /**
     *  公测下载福利码
     */
    getDownLoadCode: () => $ztService.getCodeInDownLoad(),
    /**
     *  退出登录态
     */
    logout: () => $ztService.logout()
};

export default Service;
